import axios from 'axios'

export default {
  async create (project, data) {
    try {
      const response = await axios.post(`/projects/${project}/publications`, data)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async update (publication, data) {
    try {
      const response = await axios.patch(`/publications/${publication}`, data)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async saveConfig (publication, data) {
    try {
      const response = await axios.patch(`/publications/${publication}/save-config`, data)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async saveOutline (publication, data) {
    try {
      const response = await axios.patch(`/publications/${publication}/save-outline`, data)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async publicPreviewLinkUpdate (link, data) {
    try {
      const response = await axios.post(`/links/${link}/update`, data)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  
  async updateProjectConfiguration (project, configuration) {
    try {
      const response = await axios.patch(`/projects/${project}`, { configuration })
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async destroy (publication) {
    try {
      const response = await axios.delete(`/publications/${publication}`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async saveMenu (publication, data) {
    try {
      const response = await axios.post(`/publications/${publication}/save-menu`, data)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async publish (publication, data) {
    // { all: true } OR  { locale: locale } OR null (combined)
    try {
      const response = await axios.post(`/publications/${publication}/publish`, data)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async bulkExport (project, items = []) {
    try {
      const response = await axios.post(`/projects/${project}/publications/scripts`, { items })
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async bulkPackage (project) {
    try {
      const response = await axios.post(`/projects/${project}/publications/packages`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async bulkAssetExport (project, items = []) {
    try {
      const response = await axios.get(`/projects/${project}/asset-csv`, { items })
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async selectedBulkExport (project, items = []) {
    try {
      const response = await axios.post(`/projects/${project}/publications/scripts`, { items })
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async createPublicLink (publication, locale = null) {
    try {
      const response = await axios.post(`/publications/${publication}/links/create`, { locale })
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async resetPublicLink (link) {
    try {
      const response = await axios.post(`/links/${link}/reset`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async lockPublicLink (link) {
    try {
      const response = await axios.post(`/links/${link}/lock`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async deletePublicLink (link) {
    try {
      const response = await axios.post(`/links/${link}/remove`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async deleteLocalizedZip (publicationZip) {
    try {
      const response = await axios.delete(`/package/${publicationZip}/delete`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async syncTheme (project) {
    try {
      const response = await axios.post(`/projects/${project}/sync-theme`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async generateDoc (publication, data, type) {
    try {
      const response = await axios.post(`/publications/${publication}/generate-document?type=${type}`, data)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return err
    }
  },
  async getPublicationsLite (project) {
    try {
      const response = await axios.get(`/projects/${project}/courses`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return err
    }
  },
  async createVideoScript (project, data) {
    try {
      const response = await axios.post(`/projects/${project}/videoscripts`, data)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async updateVideoScript (project, videoScript, data) {
    try {
      const response = await axios.patch(`/projects/${project}/videoscripts/${videoScript}`, data)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async deleteVideoScript (project, videoScript) {
    try {
      const response = await axios.delete(`/projects/${project}/videoscripts/${videoScript}`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async issuetrackerLink(link) {
    try {
      const response = await axios.post(`/links/${link}/issuetracker-link`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async issuetrackerUnlink(link) {
    try {
      const response = await axios.post(`/links/${link}/issuetracker-unlink`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async getPublicationData (data) {
    try {
      const response = await axios.get(`/projects/${data.project.id}/publications/${data.publication.id}/edit`, data)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  }
}